export const TOTAL_STARS_IN_MAKE = 3;

export const ANIMATION_SEC = 3;
export const SEC_START_PROCESS = 200;
export const SEC_POINTS = ANIMATION_SEC;
export const SEC_HIDE_BANNER = 990 * ANIMATION_SEC;
export const ANIMATION_PROGRESS_SEC = ANIMATION_SEC;
